// @ts-nocheck
import { LinkPresentationProps } from "@insite/mobius/Link";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { boxStyles } from "@store/Themes/common/mixins/box";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { linkGetIconProps } from "@store/Themes/common/props/link";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import EditFill from "@toolkit/Library/Components/Icons/Edit/EditFill";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface AddressProps {
    title?: TypographyProps;
    label?: TypographyProps;
    wrapper?: InjectableCss;
    wrapperSmall?: InjectableCss;
    name?: TypographyProps;
    link?: LinkPresentationProps;
    linkEdit?: LinkPresentationProps;
    box?: InjectableCss;
}

const linkProps: AddressProps["link"] = {
    css: css`
        ${linkActionStyles()}
        width: fit-content;
    `,
};

export const addressProps: AddressProps = {
    title: {
        forwardAs: "h2",
        variant: "h5",
    },
    label: {
        css: css`
            ${x => x.theme.formField.defaultProps?.labelProps?.css}
            ${spacingStyles(null, pxToRem(6))}
            display: inline-block;
            vertical-align: top;
        `,
    },
    wrapper: {
        css: css`
            ${spacingStyles(null, pxToRem(6))}
            flex-grow: 1;
        `,
    },
    wrapperSmall: {
        css: css`
            ${spacingStyles(null, pxToRem(4))}
            font-size: ${x => x.theme.design.typography.size.small};
            flex-grow: 1;
        `,
    },
    name: {
        as: "p",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    link: linkProps,
    linkEdit: mergeProps<AddressProps["linkEdit"]>(linkProps, { icon: linkGetIconProps(EditFill) }),
    box: {
        css: css`
            ${boxStyles()};
            display: flex;
            flex-direction: column;
            height: 100%;
        `,
    },
};
